import { observable } from 'mobx'
import Klient from './Klient';
import Turnus from './Turnus';
import Den from './Den';

class NovaObjednavka {

    @observable public klienti: Klient[] = [];
    @observable public turnusy: Map<number, Turnus[]> = new Map();
    @observable public dny: Map<number, Den[]> = new Map();
    @observable public slevy: Map<number, string> = new Map();
    @observable public eko: Map<number, boolean> = new Map();
    @observable public nekompletni: Map<number, boolean> = new Map();
    @observable public castecneMenu: Map<number, boolean> = new Map();
    @observable public webObjednavka: number = 0;

    public addNewClient(client: Klient) {
        this.turnusy.set(client.id, []);
        this.dny.set(client.id, []);
        this.slevy.set(client.id, '-');
        this.eko.set(client.id, false);
        this.nekompletni.set(client.id, false);
        this.castecneMenu.set(client.id, false);
        this.klienti.push(client);
    }

    public clone(): NovaObjednavka {
        const newObjednavka: NovaObjednavka = new NovaObjednavka();
        newObjednavka.loadFromEntity(this);
        return newObjednavka;
    }

    public loadFromJSON(json: any): NovaObjednavka {
        return this;
    }

    public loadFromEntity(ent: NovaObjednavka): NovaObjednavka {
        this.klienti = ent.klienti;
        this.turnusy = ent.turnusy;
        this.dny = ent.dny;
        this.slevy = ent.slevy;
        this.eko = ent.eko;
        this.nekompletni = ent.nekompletni;
        this.webObjednavka = ent.webObjednavka;
        return this;
    }
}

export default NovaObjednavka;


// WEBPACK FOOTER //
// ./src/models/NovaObjednavka.tsx